import { CSSObject } from '@emotion/react';
import { HoneycombTheme, StampColor, StampElementColors, getSizeValue, useHoneycombTheme } from '../../theming';
import { isStampThemeableColor } from '../../utils';

const getElementColors = (color: StampColor, theme: HoneycombTheme): StampElementColors => {
    const { components } = theme;
    const componentTheme = components.themes.Stamp;
    if (isStampThemeableColor(color)) {
        return componentTheme.colors[color];
    }
    return componentTheme.fixedColors[color];
};

const getColorStyles = (colors: StampElementColors, theme: HoneycombTheme): CSSObject => {
    const { background, text } = theme.fn.resolveFlatColorObject(colors);
    return {
        backgroundColor: background,
        color: text,
    };
};

export interface StampStylesParams {
    color: StampColor;
}

type StampStyleClasses = 'root';

export function useStyles({ color }: StampStylesParams): {
    styles: { [key in StampStyleClasses]: CSSObject };
} {
    const { theme } = useHoneycombTheme();

    const componentTheme = theme.components.themes.Stamp;
    const { shadow, paddingX, paddingY, radius, typographyVariant, fontWeight, lineHeight } = componentTheme;
    const TypographyProps = theme.fn.getTypographyVariant(typographyVariant);

    const shadowValue = theme.shadows[shadow];

    const root: CSSObject = {
        display: 'inline-flex',
        alignItems: 'center',
        flexDirection: 'column',
        boxShadow: shadowValue || 'none',
        padding: `${getSizeValue(paddingY)} ${getSizeValue(paddingX)}`,
        borderRadius: getSizeValue(radius),
        ...getColorStyles(getElementColors(color, theme), theme),
        fontFamily: TypographyProps.fontFamily,
        fontSize: TypographyProps.fontSize,
        textTransform: TypographyProps.textTransform,
        fontWeight: TypographyProps.fontWeight[fontWeight],
        lineHeight,
    };

    return {
        styles: {
            root,
        },
    };
}
